export default "__VITE_ASSET__Do1Zf47v__"